import { render } from "./MoneyExchangeSvg.vue?vue&type=template&id=6d40ca6a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__